export default __webpack_public_path__ + "static/media/meli.9d8eb92f.png";